import styled from 'styled-components'
import GoodSVG from '../../../assets/status/good.svg?react'
import NeutralSVG from '../../../assets/status/neutral.svg?react'
import BadSVG from '../../../assets/status/bad.svg?react'
import { useTranslation } from "react-i18next"

const NowDashboardContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #fff;
`

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-top: 24px;
  max-width: 500px;
`

const NowDashboard = ({ graphData }) => {
  const { t } = useTranslation('common')
  const status = {
    good: {
      svg: <GoodSVG />,
      text: t('user_dashboard.now.legends.good.text'),
      color: '#428262',
      auxDescription: t('user_dashboard.now.legends.good.description'),
    },
    regular: {
      svg: <NeutralSVG />,
      text: t('user_dashboard.now.legends.regular.text'),
      color: '#B26D1D',
      auxDescription: t('user_dashboard.now.legends.regular.description'),
    },
    bad: {
      svg: <BadSVG />,
      text: t('user_dashboard.now.legends.bad.text'),
      color: '#BE3756',
      auxDescription: t('user_dashboard.now.legends.bad.description'),
    },
  }

  return (
    <NowDashboardContainer>
      {status[graphData]?.svg}
      <ContentContainer>
        <span style={{ fontSize: 24 }}>
          {t('user_dashboard.main_message')}
          <span
            style={{
              fontSize: 24,
              fontWeight: 700,
              color: status[graphData]?.color,
            }}
          >
            {status[graphData]?.text}.
          </span>
        </span>

        <div style={{ marginTop: 24 }}>
          <span style={{ fontSize: 18 }}>
            {status[graphData]?.auxDescription}
          </span>
        </div>
      </ContentContainer>
    </NowDashboardContainer>
  )
}

export default NowDashboard
